import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ma-6",
  variant: "plain"
}

import Default from './default.vue'
	import Persons from './persons/index.vue'
	import WarehouseEvaluations from './warehouse_evaluations/index.vue'

	import type { ObjectContext } from '@/global'
	import type { ComputedRef } from 'vue'

	import { reactive, computed, watch } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const { $t, $store, $route, goToMainView, isNew, icons, tabSelected, loading } = useGeneral()

	const formStep = computed(() => $store.getters['forms/GET_STEP'])
	const formStepCount = computed(() => $store.getters['forms/GET_STEP_COUNT'])

	function goBack() {
		if (formStepCount.value === 1) goToMainView()
		else {
			if (formStep.value !== 1) $store.dispatch('forms/setStep', formStep.value - 1)
			else {
				loading.value = true
				goToMainView()
			}
		}
	}

	const components = {
		persons: Persons,
		warehouse_evaluations: WarehouseEvaluations
	}

	const component: ComputedRef = computed(() => {
		let selected: any = Default
		if (!isNew.value) {
			if (tabSelected.value === 'persons') selected = Persons
			else if (tabSelected.value === 'warehouse_evaluations') selected = WarehouseEvaluations
		} else {
			if (tabSelected.value === 'persons') selected = Default
			// @ts-ignore
			else if (components[tabSelected.value]) selected = components[tabSelected.value]
		}
		return selected
	})

	const state = reactive({
		tab: 'information',
		item: {},
		optionals: []
	})

	function clearTitle() {
		$store.dispatch('forms/setFormTitle', '')
	}

	const tabSelectedElement: ComputedRef<string> = computed(() => $store.getters['roles/GET_TAB_ELEMENTS'][tabSelected.value])
	const tabSelectedText: ComputedRef<string> = computed(() => $t('General_newa') + ' ' + $t(`General_${tabSelectedElement.value}`).toLowerCase())

	const formTitle: ComputedRef<string> = computed(() => $store.getters['forms/GET_FORM_TITLE'])
	const formTitleKey: ComputedRef<string> = computed(() => $store.getters['forms/GET_FORM_TITLE_KEYS'][tabSelected.value] || tabSelectedText.value)
	const title: ComputedRef<string> = computed(() => formTitle.value || $t(formTitleKey.value))

	async function init() {
		clearTitle()
		tabSelected.value = $route.params.tab
		const id = $route.params.id
		loading.value = true
		try {
			await $store.dispatch('dictionary/get', { tables: [tabSelected.value] })
			if (id && !isNew.value) {
				const item = await $store.dispatch(`${tabSelected.value}/get`, id)
				state.item = Object.assign({}, item)
			}
			loading.value = false
		} catch {
			loading.value = false
			goToMainView()
		}
	}
	init()

	watch($route, () => init())

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: _normalizeClass(["text-h4", { 'text-grey': !_unref(formTitle) }])
        }, {
          default: _withCtx(() => [
            (_unref(formStep) > 1)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  icon: "",
                  variant: "plain",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "x-large",
                      icon: _unref(icons)['arrowLeft']
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_unref(title)), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), {
      item: _unref(state).item
    }, null, 8, ["item"]))
  ]))
}
}

})